import { Text } from '@belong/ui';
import type { ImprovementsProgressModel } from 'api/models';
import { getInspectionType } from 'pages/PostInspectionFlow/utils';
import { formatString } from 'strings';
import { POST_INSPECTION_FLOW_STRINGS } from 'strings/post-inspection-flow';
import PostInspectionContentLayout from '../../../PostInspectionContentLayout/PostInspectionContentLayout';
import { getImprovementsAssignedEmployee } from '../utils';
import { ProgressItemCard } from './components/progress-item-card/progress-item-card';

type Props = {
  flow: any;
  stepConfig: any;
  stepConfigs: any;
  stepResource: any;
  stepData: ImprovementsProgressModel;
  onSaveAndNext: () => void;
};

export default function Progress({
  flow,
  stepConfig,
  stepConfigs,
  stepResource,
  stepData,
  onSaveAndNext,
}: Props) {
  const homeownerName = stepResource?.homeListingDetailsModel?.owner
    ?.firstName as string | undefined;
  const spaces = stepResource?.homeListingDetailsModel?.spaces ?? [];
  const previousReportSubType = stepData?.previousReportSubType;

  // The layout renders `title` through TextBubbleWithUserProfile, which reads
  // `employee.calendarLink` unguarded - so `employee` is not optional here.
  // Asserted like the sibling steps: a flow with no sub-type already threw.
  const inspectionType = getInspectionType(flow)!;
  const assessedBy = getImprovementsAssignedEmployee({
    employeeAssignments:
      stepResource?.homeListingDetailsModel?.employeeAssignments,
    isMoveOut: inspectionType.isMoveOut,
  });

  return (
    <PostInspectionContentLayout
      stepConfigs={stepConfigs}
      stepConfig={stepConfig}
      title={formatString(POST_INSPECTION_FLOW_STRINGS['progress.title'], {
        homeownerName,
      })}
      employee={assessedBy}
      showCityBackground={false}
      isLogoVisible={false}
    >
      <Text variant="h3" fontWeight="semibold" className="mb-xs">
        {POST_INSPECTION_FLOW_STRINGS['progress.section.title']}
      </Text>
      <Text className="mb-lg">
        {POST_INSPECTION_FLOW_STRINGS['progress.section.body']}
      </Text>

      <div className="mb-2xl flex flex-col gap-sm">
        {stepData?.items?.map((item) => (
          <ProgressItemCard
            key={item.uniqueId}
            item={item}
            spaces={spaces}
            previousReportSubType={previousReportSubType}
          />
        ))}
      </div>

      <div className="my-2xl flex justify-center">
        <PostInspectionContentLayout.CtaButton onClick={() => onSaveAndNext()}>
          {POST_INSPECTION_FLOW_STRINGS['progress.cta']}
        </PostInspectionContentLayout.CtaButton>
      </div>
    </PostInspectionContentLayout>
  );
}
